export const P = ({ children }) => <p className="text-graphite text-[15px] leading-[1.85]">{children}</p>;

export const Section = ({ title, children, testid }) => (
  <section className="mt-12" data-testid={testid}>
    <h2 className="font-anton uppercase text-2xl mb-4">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

export const Pending = ({ children }) => (
  <span className="inline-block bg-signal/10 border border-signal/40 text-signal font-mono text-[11px] uppercase tracking-wider px-2 py-0.5">
    [To be confirmed by SYNC]{children ? <> — {children}</> : null}
  </span>
);

export default function PolicyPage({ eyebrow, title, intro, children, testid }) {
  return (
    <div className="bg-ink min-h-screen pt-32 pb-28" data-testid={testid}>
      <div className="container-sync max-w-3xl">
        <p className="eyebrow mb-3">{eyebrow}</p>
        <h1 className="font-anton uppercase text-4xl sm:text-5xl mb-5">{title}</h1>
        {intro && <p className="text-graphite text-sm max-w-xl leading-relaxed">{intro}</p>}
        {children}
      </div>
    </div>
  );
}
